import { memo } from "react";

const rowStyle: React.CSSProperties = { paddingBottom: "8px" };

interface Address {
  name?: string;
  address1?: string;
  address2?: string;
  city?: string;
  province?: string;
  country?: string;
  postalCode?: string;
  phone?: string;
}

export const CustomerInformationSection = memo(
  function CustomerInformationSection({
    shippingAddress,
    billingAddress,
  }: {
    shippingAddress?: Address;
    billingAddress?: Address;
  }) {
    return (
      <div style={{ marginTop: "16px", fontSize: "16px", lineHeight: "1.5" }}>
        <table style={{ width: "100%" }}>
          <tr>
            {shippingAddress && (
              <td style={rowStyle}>
                <strong>Shipping: </strong>
              </td>
            )}
            {billingAddress && (
              <td style={rowStyle}>
                <strong>Billing: </strong>
              </td>
            )}
          </tr>
          <tr>
            {shippingAddress && <td>{shippingAddress?.name}</td>}
            {billingAddress && <td>{billingAddress?.name}</td>}
          </tr>
          <tr>
            {shippingAddress && <td>{shippingAddress?.address1}</td>}
            {billingAddress && <td>{billingAddress?.address1}</td>}
          </tr>
          <tr>
            {shippingAddress && <td>{shippingAddress?.address2}</td>}
            {billingAddress && <td>{billingAddress?.address2}</td>}
          </tr>
          <tr>
            {shippingAddress && (
              <td>
                {`${shippingAddress?.city} ${shippingAddress?.province} ${shippingAddress?.postalCode}`}
              </td>
            )}
            {billingAddress && (
              <td>
                {`${billingAddress?.city} ${billingAddress?.province} ${billingAddress?.postalCode}`}
              </td>
            )}
          </tr>
          <tr>
            {shippingAddress && <td>{shippingAddress?.phone}</td>}
            {billingAddress && <td>{billingAddress?.phone}</td>}
          </tr>
        </table>
      </div>
    );
  },
);
